import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { tgLink } from "../constants";
import TelegramIcon from "@mui/icons-material/Telegram";

const Header = ({ players, onClickHamburger, drawer }) => {
  const [isIndexPage, setIndexPage] = useState();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    setIndexPage(
      Boolean(location.pathname === "/") ||
        Boolean(location.pathname === "/registration") ||
        Boolean(location.pathname === "/rules"),
    );
  }, [location.pathname]);

  const goToHome = () => {
    if (location.pathname === "/registration") return;
    navigate("/home");
  };

  return (
    <header className="h-16 fixed w-full top-0 z-[9999]">
      <div className="h-full max-w-screen-lg mx-auto py-0 px-2 flex justify-between items-center bg-primary">
        <div
          className="flex items-center py-3 px-0 relative cursor-pointer"
          onClick={goToHome}
        >
          <div className="uppercase text-2xl font-sans text-white tracking-widest">
            ФУТБАТЛ
          </div>
          <img
            src={"/soccer-circle.svg"}
            alt=""
            className="h-10 ml-2 mr-2 rotate-90"
          />
          <div className="uppercase text-2xl font-sans text-white tracking-widest">
            ЛЧ
          </div>
        </div>
        {!isIndexPage &&
          (drawer ? (
            <CloseIcon
              className="border-solid scale-150 rounded-full p-2 cursor-pointer !text-4xl hover:text-gold"
              onClick={onClickHamburger}
            />
          ) : (
            <MenuIcon
              className="border-solid scale-150 rounded-full p-2 cursor-pointer !text-4xl hover:text-gold"
              onClick={onClickHamburger}
            />
          ))}
        {isIndexPage && (
          <a target="_blank" rel="noreferrer" href={tgLink}>
            <span className="hidden md:inline mr-2 text-white uppercase">
              Телеграм
            </span>
            <TelegramIcon className="text-cyan text-2xl" />
          </a>
        )}
      </div>
    </header>
  );
};

const mapStateToProps = (state) => ({
  players: state.players,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
